import { FIRESTORE_PREFIX, RECORD_COLLECTION } from '../constants'

export const getRecordsCollectionName = () => `${FIRESTORE_PREFIX}${RECORD_COLLECTION}`
